<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFilePdfBox } from "@mdi/js";
export default {
  name: "MdiFilePdfBox",
  data() {
    return {
      svgPath: mdiFilePdfBox,
    };
  },
};
</script>
